import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Constants } from './../../app.constants';
import { ErrorHandleService } from './error-handle.service';
import { catchError, tap } from 'rxjs/operators';


interface IFilterValue {
    sampleTypeId?: number;
    shapeTypeId?: number;
    areaId?: string;
    subAreaId?: string;
    nuclideId?: string;
    samplingYear?: string;
    reference?: string;
    samplingDepthFrom?: number;
    samplingDepthTo?: number;
    bioGroup?: string;
    taxonname?: string;
    bodyPar?: string;
    samplingDepthCoreFrom?: number;
    samplingDepthCoreTo?: number;
    sedimentType?: string;
    filterPoreSize?: string;
}

const columnValue = {
    SampleId: 'MARIS sample ID',
    SampType: 'Sample type',
    RefId: 'MARIS reference ID',
    DisplayText: 'Reference/Citation',
    ZoteroUrl: 'Zotero URL',
    RefNote: 'Reference note',
    Lab: 'Laboratory',
    Latitude: 'Latitude (decimal)',
    Longitude: 'Longitude (decimal)',
    BegPeriod: 'Sampling start date',
    EndPeriod: 'Sampling end date',
    //DecayedTo: "Decay to date",
    TotalDepth: 'Total depth (m)',
    SampleDepth: 'Sampling depth (m)',
    Station: 'Station name',
    SampleLabCode: "Data provider's sample ID",
    TaxonName: 'Taxon name',
    TaxonRepName: 'Reported taxon name',
    TaxonRank: 'Taxon rank',
    BioGroup: 'Bio group',
    TaxonDb: 'Taxon database',
    TaxonDbId: 'Taxon database ID',
    TaxonDbUrl: 'Taxon database URL',
    BodyPar: 'Body part',
    SliceUp: 'Top of core slice (cm)',
    SliceDown: 'Bottom of core slice (cm)',
    SedType: 'Sediment type',
    SedRepName: 'Reported sediment type',
    NuSymbol: 'Nuclide',
    Detection: 'Value type',
    Activity: 'Activity or MDA',
    ActivityCorr: 'Activity corrected',
    Uncertanity: 'Uncertainty',
    UncertanityCorr: 'Uncertanity corrected',
    Unit: 'Unit',
    UnitCorr: 'Unit corrected',
    Vartype: 'Variable type',
    Frequency: 'Number of data points',
    RangeLow: 'Minimum value',
    RangeUp: 'Maximum value',
    ProfileId: 'Profile ID',
    TransactId: 'Transect ID',
    Volume: 'Volume (L)',
    Salinity: 'Salinity',
    Temperature: 'Temperature (℃)',
    Filtered: 'Filtered',
    Filtpore: 'Mesh size (µm)',
    Samparea: 'Sample surface area (cm2)',
    Drywt: 'Dry weight (g)',
    Wetwt: 'Wet weight (g)',
    Percentwt: 'Dry/Wet (%)',
    Sampmet: 'Sampling method',
    Prepmet: 'Preparation method',
    Drymet: 'Drying method',
    Counmet: 'Counting method',
    SampNote: 'Sample note',
    MeasureNote: 'Measurement note',
};

@Injectable({
    providedIn: 'root',
})
export class ExportService {
    filter: any;
    columnValue: any = columnValue;
    selectedColumns: any = Object.keys(columnValue);

    constructor(
        private http: HttpClient,
        private errorHandleService: ErrorHandleService,
        private constants: Constants
    ) { }

    URL = `${this.constants.apiUrl}/Search/`;

    selectColumn(id) {
        this.selectedColumns.push(id);
    }

    exportSamples(filterValue, measurementMode: boolean = false): Observable<Response> {
        const exportColumns = this.selectedColumns;

        const obj = { searchFilter: filterValue, exportColumns: exportColumns };
        return this.http
            .post(this.URL + `exportsampledata?measurementMode=${measurementMode}`, JSON.stringify(obj), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }

    exportSamplesfromdataset(filterValue, measurementMode: boolean = false): Observable<Response> {
        const exportColumns = this.selectedColumns;

        const obj = { searchFilter: filterValue, exportColumns: exportColumns };
        return this.http
            .post(this.URL + `exportsampledatafromdataset?measurementMode=${measurementMode}`, JSON.stringify(obj), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }

    exportSamplesnetcdf(filterValue, measurementMode: boolean = false) {
        const exportColumns = this.selectedColumns;

        const obj = { searchFilter: filterValue, exportColumns: exportColumns };
        return this.http
            .post(this.URL + `exportsamplenetcdfdata?measurementMode=${measurementMode}`, JSON.stringify(obj), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }


    getnetcdffilelistfromserver(): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getnetcdffilelistfromserver`
        );

        return this.http.get<any>(uri).pipe(
            tap((_) => console.log("get datasetid")),
            catchError(this.errorHandleService.handleError("getnetcdffilelistfromserver1", []))
            
        );
    }

    //getnetcdffilelistfromserver(measurementMode: boolean = false) {

    //    return this.http
    //        .post(this.URL + `getnetcdffilelistfromserver?measurementMode=${measurementMode}`, {
    //            headers: new HttpHeaders({
    //                'Content-Type': 'application/json',
    //            }),
    //            responseType: 'blob',
    //        })
    //        .pipe(
    //            map((response: any) => {
    //                return response;
    //            })
    //        );
    //}

    exportSamplescsv(filterValue, measurementMode: boolean = false) {
        const exportColumns = this.selectedColumns;

        const obj = { searchFilter: filterValue, exportColumns: exportColumns };
        return this.http
            .post(this.URL + `exportsamplecsvdata?measurementMode=${measurementMode}`, JSON.stringify(obj), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }

    exportSpatialSamples(filterValue, measurementMode: boolean = false): Observable<Response> {
        const exportColumns = this.selectedColumns;
        const obj = {
            geoSpatialString: filterValue.geoSpatialString || filterValue.GeoSpatialString,
            geoTypeId: filterValue.geoTypeId || filterValue.GeoTypeId,
            filterValues: filterValue.filterValues,
            exportColumns: exportColumns,
            sampleId: filterValue.sampleId || filterValue.SampleId,
        };
        return this.http
            .post(this.URL + `exportgeographysampledata?measurementMode=${measurementMode}`, JSON.stringify(obj), {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'blob',
            })
            .pipe(
                map((response: any) => {
                    return response;
                })
            );
    }
}
